import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, CardContent, CardMedia, Divider, Typography, } from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import dayjs from "dayjs";
import Icon from "@shared/components/Icon";
import Link from "@shared/components/contents/link/Link";
import Button from "@dafrontcms/core/lib/cms/shared/components/contents/button/Button";
import { useLastArticlesByParent } from "@administration/hooks/ArticlesHook";
import { useSites } from "@shared/hooks/SiteHook";
const ArticleCardList = ({ link, orientation, backgroundColor = "#FFFFFF", numberArticles = "3", pageParent, ...others }) => {
    dayjs.locale("fr");
    const theme = useTheme();
    const { currentSite } = useSites();
    const articlesToTake = Number(numberArticles);
    const parentId = pageParent?.page?.id || "";
    const { data } = useLastArticlesByParent(parentId, currentSite?.id, {
        take: articlesToTake,
        skip: 0,
    });
    const dataArticles = data?.data ?? [];
    const articles = dataArticles.map((article) => ({
        id: article.id,
        title: article.title,
        image: article.image,
        date: article.publishedDate,
        link: { page: article, title: "Lire l'article" },
    }));
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { direction: orientation === "vertical" ? "column" : { xs: "column", md: "row" }, spacing: 3, useFlexGap: true, sx: { flexWrap: "wrap", justifyContent: "center" }, children: articles.map((article) => (_jsxs(Card, { component: "section", sx: {
                        display: "block",
                        height: "100%",
                        backgroundColor,
                        borderRadius: 2,
                        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                        maxWidth: { xs: "100%", md: "calc((100% - 48px) / 3)" },
                        width: "100%",
                    }, children: [article.image && (_jsx(CardMedia, { component: "img", image: article.image.url, alt: article.image.alt || "", title: article.image.title, sx: { height: 220, objectFit: "cover" } })), _jsx(CardContent, { sx: { p: 3 }, children: _jsxs(Stack, { spacing: 3, children: [article.title && (_jsx(Typography, { variant: "subtitle1", fontWeight: 600, children: article.title })), _jsx(Divider, { sx: { backgroundColor: "text.primary" } }), article.date && (_jsx(Typography, { variant: "body2", color: "text.secondary", children: dayjs(article.date).format("D MMMM YYYY") })), article.link && article.link.page && (_jsx(Button, { variant: "text", sx: {
                                            alignSelf: "flex-end",
                                            color: theme.palette.primary.main,
                                        }, endIcon: _jsx(Icon, { icon: "arrow-right" }), component: Link, ...article.link, children: article.link.title }))] }) })] }, article.id))) }), link && (link.page || link.url) && (_jsx(Button, { variant: "text", sx: {
                    display: "flex",
                    justifySelf: "center",
                    color: "primary.main",
                    mt: "16px",
                }, endIcon: _jsx(Icon, { icon: "arrow-right" }), component: Link, ...link, children: link.title }))] }));
};
export default ArticleCardList;
